import { useState } from 'react';
import { FC } from 'react';
import { Box, Divider } from '@mui/material';
import Repeater from 'src/components/repeater/Repeater';
import ProductHighlightsForm from './productHighlightsForm';
import useVendorBooth from 'src/hooks/useVendorBooth';
import ConfirmationDialog from '../controls/ConfirmationDialog';
import { ProductHighlight } from 'src/types/vendorBooth';

const VendorBoothContent: FC = () => {
  const { vendorBooth, addNewProductHighlight, updateProductHighlight, deleteProductHighlight } = useVendorBooth();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [currentItemIndex, setCurrentItemIndex] = useState<number>(0); // eslint-disable-line no-unused-vars

  const openDeleteConfirmation = (i) => {
    setDeleteConfirmationOpen(true);
    setCurrentItemIndex(i);
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <h3>Key Items To Highlight</h3>
        <h4>Choose your top 15 items and highlight them directly in your booth. (your full item listing will be shown in your show program)</h4>
        <Divider />
        <Repeater
          data={vendorBooth?.productHighlights ?? ([] as ProductHighlight[])}
          onUpdateData={updateProductHighlight}
          addNewItem={addNewProductHighlight}
          onDeleteItem={openDeleteConfirmation}
          titleField="itemNumber"
          subTitleField=""
          Form={<ProductHighlightsForm />}
        />

        {vendorBooth?.productHighlights != null && vendorBooth?.productHighlights[currentItemIndex] && (
          <ConfirmationDialog
            title="Delete Item"
            open={deleteConfirmationOpen}
            children={
              <p>
                Are you sure you want to delete <strong>{vendorBooth.productHighlights[currentItemIndex].name}</strong>?
              </p>
            }
            onClose={(confirmed) => {
              setDeleteConfirmationOpen(false);

              if (!confirmed) {
                return;
              }

              return deleteProductHighlight(currentItemIndex);
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default VendorBoothContent;
